/**
 * 活动购物车最大数量限制
 */
export const MAX_ACT_CART_COUNT = 4

//活动开始时间 2022/1/17 00:00:00
export const ACT_START_DATE = '1642348800000'

//活动开始时间 2022/1/17 00:00:00
export const ACT_END_DATE = '1644940800000'

export const ACT_DETAILS = [
  {
    //活动开始时间 2022/1/17 00:00:00
    start: 1642348800000,
    //活动结束时间 2022/3/11 00:00:00
    end: 1646928000000,
    id: '10011',
  },
  {
    //活动开始时间 2022/1/10 00:00:00
    start: 1641744000000,
    //活动结束时间 2022/1/17 00:00:00
    end: 1642348800000,
    id: '10008',
  },
]
